import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort, MatTableDataSource } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { destroyView } from '@angular/core/src/view/view';

@Component({
    selector: 'Diot-consultar',
    styleUrls: ['diot-consultar.component.scss'], 
    templateUrl: 'diot-consultar.component.html',
    providers: [generalService]
})

export class DiotConsultarComponent implements OnInit{
    myForm: FormGroup;
    dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('tableDiot1') tableDiot1: ElementRef;
    @ViewChild('tableDiot2') tableDiot2: ElementRef;
    fechaInicioOptions: { id: number, name: string }[] = [];
    public dataDiot: any[] = [];
    public dataDiotAux: any[] = [];
    public dataDiotAux2: any[] = []; 
    public dataCompany: any[] = []; 
    displayedColumns = [];
    public FISCAL_NAME = '';
    public FISCAL_RFC = ''
    public fechaExcel = '';
    public vistaExcel: boolean;
    public totalTotal = 0; 
    public totalSubtotal = 0; 
    public totalIva = 0; 
    public totalExento = 0; 

    public opcionesVista =[
        {opc: 1, des: 'Acumulado por proveedor'},
        {opc: 2, des: 'Detalle por documento'}
    ]

    constructor(private formBuilder: FormBuilder,
        private _generalService: generalService,
        private router:Router) {
        this.myForm = new FormGroup({});
        this.generateFechaInicioOptions();
    }

    ngOnInit() {
        this.buildForm();
        this.consultar_Diot();
    }

    buildForm(){
        const startMonthYear = this.fechaInicioOptions[0].id;
        this.myForm = this.formBuilder.group({
            fechaForm: [startMonthYear, Validators.required],
            vistaForm: [this.opcionesVista[0].opc, Validators.required],
        }); 
    }
    
    generateFechaInicioOptions() {
        const currentDate = moment();
        for (let i = 0; i <= 12; i++) {
          const date = currentDate.clone().subtract(i, 'months');
          this.fechaInicioOptions.push({
            id: parseInt(date.format('YYYYMM'), 10),
            name: date.format('MMMM YYYY')
          });
        }
    }
   
    consultar_Diot() {
        let diotGrid;
        this.FISCAL_NAME = '';
        this.FISCAL_RFC = '';
        this.dataSource = null;
        this.totalTotal = 0; 
        this.totalSubtotal = 0; 
        this.totalIva = 0; 
        this.totalExento = 0; 
    
        diotGrid = this.myForm.controls['vistaForm'].value;
        let fechaInt = this.myForm.controls['fechaForm'].value;
    
        this.fechaExcel = this.fechaFormatoExcel(fechaInt);

        let fechaString = fechaInt.toString(); 
        let year = parseInt(fechaString.substring(0, 4)); 
        let month = parseInt(fechaString.substring(4, 6)); 
    
        let fecha = new Date(year, month - 1);
        const params = { 
            loacs: sessionStorage.getItem('acslo'),
            fecha: fecha,
            opcionVista: diotGrid
        };
    
        this._generalService.metodoCallParams(params, 'Diot/consultarDiot', true).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                if (tableResult && tableResult.Table) {
                    this.dataDiot = tableResult.Table;
    
                    this.dataCompany = tableResult.Table1;
                    this.FISCAL_NAME = this.dataCompany[0].FISCAL_NAME;
                    this.FISCAL_RFC = this.dataCompany[0].RFC;
    
                    this.dataSource = new DataSourceGrid(this.dataDiot, this.paginator, this.sort);
                    this.dataDiotAux = this.dataDiot;
                    if (this.dataDiot.length <= 0) {
                        $(".mat-row").remove(".mat-row");
                    }
                }
            }, 
            (error) => {
                console.log(error as any);
            }
        );
        this.gridMostrar(diotGrid);
    }
    
    gridMostrar(dioutGrid: any) {
        if (dioutGrid == 1) {
            this.displayedColumns = ['PROVEEDOR','RFC','SUBTOTAL','EXENTO','IVA','TOTAL'];
            this.vistaExcel = true;
        } else {
            this.displayedColumns = ['FECHA','COMPRA','PROVEEDOR','RFC','SUBTOTAL','IVA','TOTAL'];
            this.vistaExcel = false;
        }
    }
    //-------------------------------------Excel--------------------------------
    fechaFormatoExcel(fechaInt): string {
        const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
        // Extraer el año y el mes
        let year = Math.floor(fechaInt / 100);
        let month = fechaInt % 100;
        let monthName = monthNames[month - 1];
        // Formar la cadena "Mes Año"
        let formattedDate = `${monthName} ${year}`.toUpperCase();
        return formattedDate; 
    }
    
    preparaExcelAcumuladoProveedor(){
        //Redondeo
        this.dataDiotAux = this.dataDiot.map(item => ({
            ...item,
            SUBTOTAL: Math.round(item.SUBTOTAL),
            TOTAL: Math.round(item.TOTAL),
            IVA: Math.round(item.IVA),
            EXENTO: Math.round(item.EXENTO)
        }));

        // Sumar valores redondeados
        const totalSUBTOTAL = this.dataDiotAux.reduce((sum, item) => sum + item.SUBTOTAL, 0);
        const totalTOTAL = this.dataDiotAux.reduce((sum, item) => sum + item.TOTAL, 0);
        const totalIVA = this.dataDiotAux.reduce((sum, item) => sum + item.IVA, 0);
        const totalEXENTO = this.dataDiotAux.reduce((sum, item) => sum + item.EXENTO, 0);

        this.totalSubtotal = totalSUBTOTAL;
        this.totalTotal = totalTOTAL;
        this.totalIva = totalIVA;
        this.totalExento = totalEXENTO;

        // Ordenar la lista de mayor a menor por SUBTOTAL
        this.dataDiotAux.sort((a, b) => b.SUBTOTAL - a.SUBTOTAL);
        //------------------------------------------------
        const diezPorcientoSUBTOTAL = totalSUBTOTAL * 0.10;

        let sumaAcumulada = 0;
        this.dataDiotAux2 = [];
        const nuevaLista = [];

        // Separar los elementos según la suma acumulada
        // this.dataDiotAux.forEach(item => {
        //     if (sumaAcumulada + item.SUBTOTAL <= diezPorcientoSUBTOTAL) {
        //         sumaAcumulada += item.SUBTOTAL;
        //         nuevaLista.push(item);
        //     } else {
        //         this.dataDiotAux2.push(item);
        //     }
        // });
        for (let i = this.dataDiotAux.length - 1; i >= 0; i--) {
            const item = this.dataDiotAux[i];
            if (sumaAcumulada + item.SUBTOTAL <= diezPorcientoSUBTOTAL) {
                sumaAcumulada += item.SUBTOTAL;
                this.dataDiotAux2.push(item);
            } else {
                nuevaLista.push(item);
            }
        }

        this.dataDiotAux = nuevaLista;

        this.dataDiotAux.sort((a, b) => b.SUBTOTAL - a.SUBTOTAL);
        this.dataDiotAux2.sort((a, b) => b.SUBTOTAL - a.SUBTOTAL);

        //elemntos de this.dataDiotAux2 
        const totalSUBTOTAL2 = this.dataDiotAux2.reduce((sum, item) => sum + item.SUBTOTAL, 0);
        const totalTOTAL2 = this.dataDiotAux2.reduce((sum, item) => sum + item.TOTAL, 0);
        const totalIVA2 = this.dataDiotAux2.reduce((sum, item) => sum + item.IVA, 0);
        const totalEXENTO2 = this.dataDiotAux2.reduce((sum, item) => sum + item.EXENTO, 0);

        let SUBTOTAL = 0;
        SUBTOTAL = totalSUBTOTAL2;
        let TOTAL = 0
        TOTAL = totalTOTAL2;
        let IVA = 0;
        IVA = totalIVA2;
        let EXENTO = 0;
        EXENTO = totalEXENTO2;

        const nuevoRegistro = {
            SUBTOTAL: totalSUBTOTAL2,
            TOTAL: totalTOTAL2,
            IVA: totalIVA2,
            EXENTO: totalEXENTO2,
            CUSTOMER_NAME: 'PROVEEDOR GLOBAL'
        };
        
        this.dataDiotAux.push(nuevoRegistro);
    }
    
    exportarExcel() {
        if (this.dataDiot.length > 0) {
            if(this.vistaExcel){
                this.preparaExcelAcumuladoProveedor();
            }
            this.readyExport(this.vistaExcel);
        }
    }
    
    readyExport(bandera) {
        let nombreArchivo = '';
        nombreArchivo = bandera ? 'DIOT Acumulado por proveedor' : 'DIOT Detalle por compra';
        setTimeout(() => this.exportAsExcelFile(nombreArchivo + " " + this.fechaExcel), 500);
    }
    
    exportAsExcelFile(filename: string): void {
        let worksheet: XLSX.WorkSheet;
        let headersWorksheet: string[];
    
        if (this.vistaExcel) { // true es Acumulado por proveedor
            worksheet = XLSX.utils.table_to_sheet(this.tableDiot1.nativeElement);
            headersWorksheet = ['NO.','PROVEEDOR','PROVEEDOR GLOBAL:','RFC','SUBTOTAL','EXENTO','IVA','TOTAL'];
        } else {
            worksheet = XLSX.utils.table_to_sheet(this.tableDiot2.nativeElement);
            headersWorksheet = ['FECHA', 'COMPRA', 'PROVEEDOR', 'RFC', 'SUBTOTAL', 'IVA', 'TOTAL'];
        }
    
        // Aplicar formato a las celdas
        for (const z in worksheet) {
            if (z[0] === '!') continue;
    
            const cell = worksheet[z];
            if (cell) {
                const col = z.replace(/[0-9]/g, '');
                const cellValue = cell.v;
    
                let cellStyle: any = { alignment: { vertical: 'center', horizontal: 'center' } };
    
                if (headersWorksheet.indexOf(cellValue + '') > -1) {
                    cellStyle.font = { bold: true };
                    cellStyle.numFmt = '@'; // Forzar texto para los encabezados
                } else if (typeof cellValue === 'number') {
                    if (headersWorksheet[0] === 'NO.' && col === 'A') { // Suponiendo que 'NO.' es la primera columna
                        cellStyle.numFmt = '0'; // Formato entero para la columna 'NO.'
                    } else {
                        cellStyle.numFmt = '$#,##0.00'; // Formato de moneda para otras celdas numéricas
                        // if (cellValue < 0) {
                        //     cellStyle.font = { color: { rgb: 'FF0000' } }; // Rojo para valores negativos
                        // }
                    }
                } else if (typeof cellValue === 'string' && cellValue.startsWith('$')) {
                    cellStyle.numFmt = '$#,##0.00'; // Formato de decimal para celdas con '$'
                } else {
                    cellStyle.numFmt = '@'; // Texto por defecto
                }
    
                // Aplica el estilo a la celda
                this.setCellStyle(cell, cellStyle);
            }
        }
    
        const workbook: XLSX.WorkBook = { Sheets: { General: worksheet }, SheetNames: ['General'] };
        const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    
        this.saveAsExcelFile(excelBuffer, filename);
    }
    
    saveAsExcelFile(buffer: any, filename: string): void {
      const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
      FileSaver.saveAs(data, filename + '.xlsx');
    }
    
    wrapAndCenterCell(cell: XLSX.CellObject, tipo: string) {
      let cellStyle: any = { alignment: { vertical: 'center', horizontal: 'center' } }; 
    
      switch (tipo) {
        case 'header':
          cellStyle.font = { bold: true }; 
          cellStyle.numFmt = '@'; // Texto para los encabezados
          break;
        case 'decimal':
          cellStyle.numFmt = '$#,##0.00'; 
          if (typeof cell.v === 'number' && cell.v < 0) {
            cellStyle.font = { color: { rgb: 'FF0000' } }; // Poner en rojo los valores negativos
          }
          break;
        case 'porcentaje':
          cellStyle.numFmt = '0.00%;\\(0.00%\\);\\-;@'; 
          break;
      }
    
      this.setCellStyle(cell, cellStyle); 
    }
    
    setCellStyle(cell: XLSX.CellObject, style: any) {
      cell.s = style;
    }
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/diot/consultar/diot-consultar.component.ts